import { useEffect, useState } from 'react';
import { useFindByQuery } from '../../graphql';

export interface Role {
  id: string;
  name: string;
}

export const useRoles = () => {
  const [roles, setRoles] = useState<Role[]>([]);
  const { data, isLoading, invalidateQuery } = useFindByQuery({
    modelName: 'role',
    query: GET_ROLES,
  });

  useEffect(() => {
    if (data && data.items) {
      setRoles(data.items);
    }
  }, [data]);

  return {
    roles,
    isLoading,
    invalidateQuery,
  };
};

const GET_ROLES = `
  query FindRoles {
    findRoles(filter: {
      type: { eq: "ACCOUNT" }
    }) {
      items {
        id
        name
      }
    }
  }
`;

export enum RoleKey {
  GLOBAL_ADMIN = 'globalAdmin',
  WORKSPACE_ADMIN = 'admin',
  GENERAL = 'general',
  RESTRICTED = 'restricted',
  GUEST = 'guest',
}

export const RoleNameMap: Record<RoleKey, string> = {
  [RoleKey.GLOBAL_ADMIN]: 'Global Admin',
  [RoleKey.WORKSPACE_ADMIN]: 'Workspace Admin',
  [RoleKey.GENERAL]: 'General',
  [RoleKey.RESTRICTED]: 'Restricted',
  [RoleKey.GUEST]: 'Guest',
};

export const RoleNameToKeyMap: Record<string, RoleKey> = Object.fromEntries(
  Object.entries(RoleNameMap).map(([key, value]) => [value, key as RoleKey])
);
